import { storyblokEditable } from "@storyblok/react";
import Link from "next/link";
import React from "react";

const ServiceSingleButtonSmaller = ({ blok }) => (
  <div className="singlebuttonsmaller-outerwrap">
    <div className="singlebuttonsmaller-wrap inner-wrap" {...storyblokEditable(blok)}>
      {blok.link && (
        <Link href={blok.link} >
          <button className="button-default-width">{blok.button}</button>
        </Link>
      )}
      {blok.linknewtab && (
        <Link target="_blank" href={blok.linknewtab} >
            <button className="button-default-width">
              {blok.buttonnewtab}
            </button>
        </Link>
      )}
    </div>
  </div>
);

export default ServiceSingleButtonSmaller;
